// ============================================================================
// BFS-DP HYBRID - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bfs-dp-hybrid',
  name: 'BFS-DP Hybrid',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'A hybrid algorithm combining Breadth-First Search with dynamic programming techniques to solve complex graph problems that require both traversal and memoization.'
};
